import * as z from "zod/v4";
import { addressHumanInputSchema } from "../../addresses";
import {
	AcquisitionReferralStatusEnum,
	REFERRAL_ADDRESS_NOT_SELECTED,
	referrerEmailSchema,
	stagedReferralPhotoSchema
} from "../referrals";

export const acquisitionReferralFormSchema = z.object({
	id: z.uuidv4("Referral ID is required"),
	address: z
		.string()
		.min(1, "Please enter a valid address")
		.max(255, "Address must be less than 255 characters"),
	addressComponents: addressHumanInputSchema.nullable().default(null),
	referredBy: z.string().min(1, "Referred by is required"),
	notes: z
		.string()
		.min(10, "Please provide at least 10 characters")
		.max(1000, "Notes must be less than 1000 characters"),
	referrerEmail: referrerEmailSchema,
	status: z
		.enum(AcquisitionReferralStatusEnum)
		.default(AcquisitionReferralStatusEnum.NewReferral),
	turnstileToken: z.string(),
	pageUrl: z.url(),
	routeId: z.string(),
	utmSource: z.string(),
	utmMedium: z.string(),
	utmCampaign: z.string(),
	utmContent: z.string(),
	utmTerm: z.string()
});

export type AcquisitionReferralFormSchema = z.infer<typeof acquisitionReferralFormSchema>;

export const acquisitionReferralFormClientSchema = acquisitionReferralFormSchema
	.pick({
		address: true,
		addressComponents: true,
		referredBy: true,
		notes: true,
		referrerEmail: true,
		turnstileToken: true
	})
	.superRefine((form, ctx) => {
		if (form.address.trim() && !form.addressComponents)
			ctx.addIssue({
				code: "custom",
				path: ["address"],
				message: REFERRAL_ADDRESS_NOT_SELECTED
			});
	});

export const acquisitionReferralSubmitSchema = acquisitionReferralFormSchema.extend({
	addressComponents: addressHumanInputSchema,
	photos: z.array(stagedReferralPhotoSchema).min(1, "At least 1 photo is required.")
});

export const confirmMediaUploadSchema = z.object({
	id: z.uuidv4("Referral ID is required"),
	fileDisplayName: z.string().min(1, "File display name is required"),
	b2UploadResult: z.object({
		bucketId: z.string(),
		fileName: z.string(),
		contentType: z.string(),
		contentLength: z.number(),
		fileId: z.string()
	})
});

export type ConfirmMediaUploadSchema = z.infer<typeof confirmMediaUploadSchema>;
